export default {"src":"/_next/static/media/visa.bb63c034.svg","height":35,"width":108,"blurWidth":0,"blurHeight":0};